import { search } from "../../../../BaseRepositoryComponents";

const path = `${process.env.REACT_APP_URL_API_ERP}/erp/nf/declaracaoimportacao/v1`;
const token = process.env.REACT_APP_TOKEN_API_ERP;

const headers = new Headers();
headers.append("Authorization", token);
headers.append("content-type", "application/json");

const index = async ({ empresa_cnpj }) =>
  search(`${path}?empresa_cnpj=${empresa_cnpj}`, "GET", headers);

const getAdditionItems = async ({ empresa_cnpj, ids }) =>
  search(
    `${path}/adicaoitens?empresa_cnpj=${empresa_cnpj}${ids && `&ids=${ids}`}`,
    "GET",
    headers
  );

export { index, getAdditionItems };
